export default class Status {
  static SUCCESS = 200
  static BAD_REQUEST = 400
  static UNAUTHORIZED = 401
  static FORBIDDEN = 403
  static NOT_FOUND = 404
  static INTERNAL_SERVER_ERROR = 500
  static SERVICE_UNAVAILABLE = 503
}
